export default __webpack_public_path__ + "static/media/diet_eating_pattern.3bf8f1e1.png";